
import * as React from "react";
import { useNavigation } from "react-day-picker";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface CustomCaptionProps {
  displayMonth: Date;
  selectedMonth: Date;
  setSelectedMonth: (date: Date) => void;
}

export function CustomCaption({ 
  displayMonth, 
  selectedMonth,
  setSelectedMonth
}: CustomCaptionProps) {
  const { goToMonth } = useNavigation();
  
  // Generate month options
  const months = [
    "January", "February", "March", "April", "May", "June", 
    "July", "August", "September", "October", "November", "December"
  ];
  
  // Generate year options (10 years before and after current year)
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 21 }, (_, i) => currentYear - 10 + i);
  
  const currentMonth = displayMonth.getMonth();
  const currentMonthYear = displayMonth.getFullYear();
  
  const handleMonthChange = (value: string) => {
    const newMonth = parseInt(value, 10);
    const newDate = new Date(displayMonth);
    newDate.setMonth(newMonth);
    setSelectedMonth(newDate);
    goToMonth(newDate);
  };
  
  const handleYearChange = (value: string) => {
    const newYear = parseInt(value, 10);
    const newDate = new Date(displayMonth);
    newDate.setFullYear(newYear);
    setSelectedMonth(newDate);
    goToMonth(newDate);
  };
  
  // Stop propagation of all events to prevent calendar from closing
  const stopPropagation = (e: React.SyntheticEvent) => {
    e.stopPropagation();
  };
  
  return (
    <div 
      className="flex items-center justify-between gap-2 px-1 w-full" 
      onClick={stopPropagation}
      onMouseDown={stopPropagation}
      onPointerDown={stopPropagation}
    >
      <Select
        value={currentMonth.toString()}
        onValueChange={handleMonthChange}
      >
        <SelectTrigger 
          className="h-7 flex-1 text-xs font-medium min-w-[130px]"
          onClick={stopPropagation}
        >
          <SelectValue placeholder={months[currentMonth]} />
        </SelectTrigger>
        <SelectContent className="z-[100]">
          {months.map((month, index) => (
            <SelectItem key={month} value={index.toString()} className="text-xs">
              {month}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      
      <Select
        value={currentMonthYear.toString()}
        onValueChange={handleYearChange}
      >
        <SelectTrigger 
          className="h-7 flex-1 text-xs font-medium min-w-[90px]"
          onClick={stopPropagation}
        >
          <SelectValue placeholder={currentMonthYear.toString()} />
        </SelectTrigger>
        <SelectContent className="z-[100]">
          {years.map((year) => (
            <SelectItem key={year} value={year.toString()} className="text-xs">
              {year}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
